var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-flatform-tip"},[_c('i',{staticClass:"el-alert__icon el-icon-info"}),_vm._v(" "+_vm._s(_vm.getTipText())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }